module.exports = __webpack_public_path__ + "static/media/team_2.559f9804.jpeg";